import { render, staticRenderFns } from "./DatasheetButton.vue?vue&type=template&id=34b02c25&"
import script from "./DatasheetButton.vue?vue&type=script&lang=js&"
export * from "./DatasheetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\energy_label_plugin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b02c25')) {
      api.createRecord('34b02c25', component.options)
    } else {
      api.reload('34b02c25', component.options)
    }
    module.hot.accept("./DatasheetButton.vue?vue&type=template&id=34b02c25&", function () {
      api.rerender('34b02c25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/DatasheetButton.vue"
export default component.exports